import React from "react";

import { ParkNumberCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function parkNumber({ width, onResize }: Column.Options) {
	return base(ColumnId.ParkNumber, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default parkNumber;
